import React, { Component } from 'react';
import Header from '../common/layout/header';
import Footer from '../common/layout/footer';
import DataTable from 'react-data-table-component';
import { BaseUrl } from '../common/config';
import Sidebar from '../common/sidebar';
import moment from 'moment';
import { http } from '../helper';
import { capitalizeFirstLetter, dateformatwithuktime } from "../utilityfunctions";


class PromoOffers extends Component {



    constructor(props) {
        super(props);
        this.state = {
            searchTextVal: "",
            promotionslist: [],
            templist: [],
            loading: true,
            popupView: "",
            visibleAlert: false,
            freeproductpdfvalue: '',
            activeTab: "cart",
            sectorPromotionsList: [],
            sectorOptions: [],
            searchSectorTextVal: "",
            sectorVal: '',
            deleteAlert: false
        };

        if (!sessionStorage.getItem("isLoggedIn")) {
            window.location.href = '/';
        }
        if (JSON.parse(sessionStorage.getItem('authData')) != '' && !JSON.parse(sessionStorage.getItem('authData')).adminRole.permissions.includes('manage_promooffers')) {
            window.location.href = '/unauthorized';
        }

    }

    handleTabChange = (tab) => {
        const url = new URL(window.location);
        url.searchParams.set("tab", tab);
        window.history.pushState({}, "", url);
        this.setState({ activeTab: tab, loading: true }, () => {
            if (tab === "cart") {
                this.getPromotionslist();
            } else {
                this.getSectorPromotionsList();
            }
        });
    };

    getPromotionslist() {
        this.setState({ loading: true });
        var loginDetails = {};
        if (sessionStorage.getItem('authData')) {
            loginDetails = JSON.parse(sessionStorage.getItem('authData'));
        }
        let URL = BaseUrl + "admin/listpromooffers";
        http.get(URL).then((response) => {
            // Sort by sortOrder
            let responseData = response.data.data.sort((a, b) => a.cartAmountTarget - b.cartAmountTarget);
            this.setState({ promotionslist: responseData, loading: false, templist: responseData });
        }).catch((err) => {
            console.log(err);
            this.setState({ loading: false });
        })
    }

    getSectorPromotionsList() {
        var loginDetails = {};
        if (sessionStorage.getItem('authData')) {
            loginDetails = JSON.parse(sessionStorage.getItem('authData'));
        }
        let URL = BaseUrl + "admin/listsectorpromooffers";

        http.get(URL).then((response) => {
            console.log("Sector Promotions Response:", response);
            let responseData = response.data.data.sort((a, b) => a.cartAmountTarget - b.cartAmountTarget);
            this.setState({ sectorPromotionsList: responseData, loading: false, templist: responseData });
        }).catch((err) => console.log(err));
    }

    editPromoOffers = (editid) => {

        window.location.href = `/promooffers/edit/${editid}`;

    };

    editsectorPromoOffers = (editid) => {

        window.location.href = `/promooffers/sector/edit/${editid}`;

    };
    deletePromoOffers = (value) => {
        this.setState({ visibleAlert: true, freeproductpdfvalue: value });
    }
    deletePromoOffersdetails = () => {
        var loginDetails = {};
        if (sessionStorage.getItem('authData')) {
            loginDetails = JSON.parse(sessionStorage.getItem('authData'));
        }
        let URL = BaseUrl + `admin/deletepromooffers/${this.state.freeproductpdfvalue._id}`;
        http.delete(URL).then(async (response) => {

            if (response.data.success === true) {

                window.location.reload();
            }


        }).catch((err) => {
            console.log(err);

        });


    }

    alertPopupclose = () => {
        this.setState({ visibleAlert: false, freeproductvalue: '' });
    }

    deletesectorPromoOffers = (value) => {
        this.setState({ deleteAlert: true, sectorVal: value });
    }

    deletesectorPromoOffersdetails = () => {
        var loginDetails = {};
        if (sessionStorage.getItem('authData')) {
            loginDetails = JSON.parse(sessionStorage.getItem('authData'));
        }
        let URL = BaseUrl + `admin/deletesectorpromooffers/${this.state.sectorVal._id}`;
        http.delete(URL).then(async (response) => {

            if (response.data.success === true) {
                window.location.reload();
            }
        }).catch((err) => {
            console.log(err);

        });
    }
    alertDeletePopupclose = () => {
        this.setState({ deleteAlert: false, sectorVal: '' });
    }

    // componentDidMount() {
    //     this.getPromotionslist();
    // }

    componentDidMount() {
        const params = new URLSearchParams(window.location.search);
        const tab = params.get("tab");

        if (tab === "sector") {
            this.setState({ activeTab: "sector" }, () => {
                this.getSectorPromotionsList();
            });
        } else {
            this.setState({ activeTab: "cart" }, () => {
                this.getPromotionslist();
            });
        }
    }

    addPromotion = () => {
        window.location.href = '/promooffers/add'
    }

    addSectorPromotion = () => {
        window.location.href = '/promooffers/sector/add'
    }

    handleReset = () => {
        this.setState({ searchTextVal: '', promotionslist: this.state.templist });
    };

    handleChange = async (value) => {
        this.setState({ searchTextVal: value });
        this.filterData(value);
    };

    handleSectorChange = async (value) => {
        this.setState({ searchSectorTextVal: value });
        this.filterSectorData(value);
    }

    handleSectorReset = () => {
        this.setState({ searchSectorTextVal: '', sectorPromotionsList: this.state.templist });
    };

    filterSectorData = async (value) => {

        let accoun = this.state.templist;
        let result = [];
        if (value.length > 0) {
            accoun.map((item) => {
                if (item.cartAmountFrom == value || item.cartAmountTo == value || item.sectorName.toLowerCase().includes(value.toLowerCase())) {
                    result.push(item);
                }
            })
            this.setState({ sectorPromotionsList: result });
        } else {
            this.setState({ sectorPromotionsList: accoun });
        }
    };

    filterData = async (value) => {

        let accoun = this.state.templist;

        let result = [];
        if (value.length > 0) {
            accoun.map((item) => {

                if (item.cartAmountFrom == value || item.cartAmountTo == value) {
                    result.push(item);
                }
            })
            this.setState({ promotionslist: result });
        } else {
            this.setState({ promotionslist: accoun });
        }
    };

    priceFormat(price) {
        if (price == null || isNaN(price)) {
            return "£0.00"; // Default value if price is null, undefined, or not a number
        }
        return price.toLocaleString("en-US", {
            style: "currency",
            currency: "GBP",
            minimumFractionDigits: 2,
        });
    };

    fetchSectors = async () => {
        try {
            //this.setState({ isSectorLoading: true });

            const URL = `${BaseUrl}admin/product/masterentries/sectors`;
            const response = await http.get(URL);

            if (response.data?.success) {
                const sectors = response.data.data;

                const formatted = sectors.map((item) => ({
                    name: item.MasterValue,
                    value: item.MasterId,
                }));

                this.setState({ sectorOptions: formatted });
            }

        } catch (err) {
            console.error("Failed to fetch sectors", err);
        }
    };


    render() {

        const columns = [
            {
                name: "Cart Value From",
                selector: row => this.priceFormat(row.cartAmountFrom),
                sortable: true,
            },
            {
                name: "Cart Value To",
                selector: row => this.priceFormat(row.cartAmountTo),
                sortable: true,
            },
            {
                name: "Target Cart Value",
                selector: row => this.priceFormat(row.cartAmountTarget),
                sortable: true,
            },
            {
                name: "Status",
                selector: row => capitalizeFirstLetter(row.Status),
                sortable: true,
            },
            {
                name: "Date Created",
                selector: row => dateformatwithuktime(row.createdAt),
                sortable: true,
            },
            {
                name: "Actions",
                selector: row => <div style={{ display: "flex" }}>
                    <a className='editbtn button title-tooltip title-up' data-title='Edit' style={{ color: "white" }} onClick={() => this.editPromoOffers(row._id)}><i className="fa fa-pencil" aria-hidden="true"></i></a>
                    <a className='editbtn button title-tooltip title-up' data-title='Delete' style={{ color: "white" }} onClick={() => this.deletePromoOffers(row)}><i className="fa fa-trash" aria-hidden="true"></i></a>


                </div>,
                sortable: false,
            }
        ];
        
         const sectorColumns = [
            {
                name: "Sector",
                selector: row => row.sectorName,
                sortable: true,
            },
            // {
            //     name: "Cart Value From",
            //     selector: row => this.priceFormat(row.cartAmountFrom),
            //     sortable: true,
            // },
            // {
            //     name: "Cart Value To",
            //     selector: row => this.priceFormat(row.cartAmountTo),
            //     sortable: true,
            // },
            {
                name: "Target Cart Value",
                selector: row => `> ${this.priceFormat(row.cartAmountTarget)}`,
                sortable: true,
            },
            {
                name: "Status",
                selector: row => capitalizeFirstLetter(row.Status),
                sortable: true,
            },
            {
                name: "Date Created",
                selector: row => dateformatwithuktime(row.createdAt),
                sortable: true,
            },
            {
                name: "Actions",
                selector: row => {
                    //const canEdit = canAction('manage_promooffers', 'edit');
                    return (
                        <div style={{ display: "flex" }}>
                            <a className='editbtn button title-tooltip title-up' data-title='Edit' style={{ color: "white" }} onClick={() => this.editsectorPromoOffers(row._id)}><i className={`fa fa-pencil`} aria-hidden="true"></i></a>
                            
                                <a className='editbtn button title-tooltip title-up' data-title='Delete' style={{ color: "white" }} onClick={() => this.deletesectorPromoOffers(row)}><i className="fa fa-trash" aria-hidden="true"></i></a>
                            
                        </div>
                    )
                },
                sortable: false,
            }
        ];

        const customStyles = {
            rows: {
                style: {
                    minHeight: '25px',
                },
            },
            headCells: {
                style: {
                    padding: '8px', // override the cell padding for head cells

                },
            },
            cells: {
                style: {
                    padding: '8px', // override the cell padding for data cells

                },
            },
        };

        const paginationComponentOptions = {
            rowsPerPageText: '',
            rangeSeparatorText: '',
            selectAllRowsItem: true,
            selectAllRowsItemText: '',
            noRowsPerPage: '',
        };
        const conditionalRowStyles = [
            {
                when: row => moment(row.FromDate, "YYYY-MM-DD").isBefore(moment(), 'day'),
                style: {
                    backgroundColor: "#ffcccc", // Light red for expired rows
                    color: "#000", // Optional: Adjust text color for visibility
                },
            },
        ];


        return (
            <>
                <div className="dashboard-block">

                    <Sidebar />

                    <div className="dash-left">
                        <Header />

                        <section className="cart-block">
                            <div className="container food-partner-cms">
                                <h1 className="checkout-title">Promo Offers</h1>

                                <div className="right-table-outer-wrap">

                                    {this.state.activeTab === "cart" ? (
                                        <><div className="table-filter search-orders">
                                            <div className='table-search-reset'>
                                                <div className="table-search">
                                                    <input type="text" value={this.state.searchTextVal} onChange={e => this.handleChange(e.target.value)} className="form-control" placeholder="Search by Cart Amount" />

                                            </div>
                                            <button className='submitbtn button search-ord-btn' onClick={e => this.filterData(this.state.searchTextVal)}><i className="fa fa-search"></i></button>

                                            <button className='resetbtn' type='reset' onClick={this.handleReset}>Reset</button>
                                        </div>

                                        <div className='add-holidaybtn'>
                                            <button className='addbtn' onClick={this.addPromotion}>Add</button>
                                                </div>
                                        </div></>
                                    ) : (
                                        <> <div className="table-filter search-orders">
                                            <div className='table-search-reset'>
                                                <div className="table-search">
                                                    <input type="text" value={this.state.searchSectorTextVal} onChange={e => this.handleSectorChange(e.target.value)} className="form-control" placeholder="Search by Sector and Cart Amount" />

                                                </div>
                                                <button className='submitbtn button search-ord-btn' onClick={e => this.filterSectorData(this.state.searchSectorTextVal)}><i className="fa fa-search"></i></button>

                                                <button className='resetbtn' type='reset' onClick={this.handleSectorReset}>Reset</button>
                                            </div>
                                            
                                                <div className='add-holidaybtn'>
                                                    <button className='addbtn' onClick={this.addSectorPromotion}>Add</button>
                                                </div>
                                            
                                        </div>
                                        </>
                                    )}
                                    <div className="header-tab-menu">
                                        <a
                                            className={this.state.activeTab === "cart" ? "active" : ""}
                                            onClick={() => this.handleTabChange("cart")}
                                        >
                                            Cart Based Promo Offers
                                        </a>

                                        <a
                                            className={this.state.activeTab === "sector" ? "active" : ""}
                                            onClick={() => this.handleTabChange("sector")}
                                        >
                                            Sector Based Promo Offers
                                        </a>
                                    </div>
                                    {this.state.activeTab === "cart" ? (
                                        <>
                                            <div className="table_overflow promotions-data-table">
                                                <DataTable
                                                    columns={columns}
                                                    noDataComponent={<div className='no-records-found'>Sorry, there are no promo offer matching your keyword, try a new search.</div>}
                                                    data={this.state.promotionslist}
                                                    customStyles={customStyles}
                                                    pagination
                                                    paginationPerPage={50}
                                                    progressPending={this.state.loading}
                                                    paginationRowsPerPageOptions={[50, 100, 150, 200]}
                                                    paginationComponentOptions={paginationComponentOptions}
                                                    conditionalRowStyles={conditionalRowStyles} // Apply row highlighting

                                        />


                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="table_overflow promotions-data-table">
                                                <DataTable
                                                    columns={sectorColumns}
                                                    noDataComponent={<div className='no-records-found'>Sorry, there are no promo offer matching your keyword, try a new search.</div>}
                                                    data={this.state.sectorPromotionsList}
                                                    pagination
                                                    paginationPerPage={50}
                                                    progressPending={this.state.loading}
                                                    customStyles={customStyles}
                                                    paginationRowsPerPageOptions={[50, 100, 150, 200]}
                                                    paginationComponentOptions={paginationComponentOptions}
                                                    conditionalRowStyles={conditionalRowStyles}
                                                />
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </section>

                        <Footer />
                    </div>
                </div>

                {this.state.visibleAlert === true &&
                    <div className='custom-alert-pop paylater-popup'>
                        <div className='custom-alert-container'>
                            <div className='custom-alert-wrap'>
                                <div className='custom-alert-header'>
                                    <h4>Alert</h4>
                                </div>
                                <div className='custom-alert-body'>
                                    <p>Are you sure you want to delete?</p>

                                    <div className='alert-buttons'>

                                        <a onClick={this.deletePromoOffersdetails.bind(this)} className="popup-alert-btn button" >OK</a>
                                        <a onClick={this.alertPopupclose.bind(this)} className="popup-alert-btn button">Cancel</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}

                {this.state.deleteAlert === true &&
                    <div className='custom-alert-pop paylater-popup'>
                        <div className='custom-alert-container'>
                            <div className='custom-alert-wrap'>
                                <div className='custom-alert-header'>
                                    <h4>Alert</h4>
                                </div>
                                <div className='custom-alert-body'>
                                    <p>Are you sure you want to delete?</p>

                                    <div className='alert-buttons'>

                                        <a onClick={this.deletesectorPromoOffersdetails.bind(this)} className="popup-alert-btn button" >OK</a>
                                        <a onClick={this.alertDeletePopupclose.bind(this)} className="popup-alert-btn button">Cancel</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}

            </>
        );
    }
}

export default PromoOffers;